var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { attrs: { id: "content" } }, [
      _c("nav", { staticClass: "nav nav-tabs nav-justified" }, [
        _c(
          "a",
          {
            staticClass: "nav-item nav-link",
            class: [_vm.currentTab === "upcoming" ? "active" : ""],
            attrs: { href: "#upcoming" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.showMyOrders("upcoming")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.my_reservations.upcoming")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav-item nav-link",
            class: [_vm.currentTab === "past" ? "active" : ""],
            attrs: { href: "#past" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.showMyOrders("past")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.my_reservations.past")) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-content", attrs: { id: "my-tab-content" } },
        [
          _c("order-list", { ref: "orders", attrs: { status: _vm.currentTab } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68f7ca82", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f7ca82","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/MyOrders.vue
// module id = 1672
// module chunks = 0